// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-delete-customer-user-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    font-family: lato, "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
}
.tenant-administrator-delete-customer-user-container{
    position: relative;
    opacity: 0;
    padding: 10px 40px;
    border-radius: 6px;
    background-color: white;
    animation: tenant-administrator-delete-customer-user-slide-in 0.8s ease-in forwards;
}
@keyframes tenant-administrator-delete-customer-user-slide-in {
    from{
        opacity: 0;
        transform: translateX(-100%);
    }
    80%{
        opacity: 1;
        transform: translateX(-8%);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
.tenant-administrator-delete-customer-user-container h1{
    margin: 25px 0px;
    margin-right: 140px;
    font-size: 24px;
    font-weight: 700;
    cursor: default;
    color: rgb(30, 30, 33);
}
.tenant-administrator-delete-customer-user-container p{
    font-size: 15px;
    margin: 30px 0px;
    cursor: default;
    color: rgb(30, 30, 33);
}
.tenant-administrator-delete-customer-user-buttons-container{
    margin: 20px 0px;
    text-align: right;
}
.tenant-administrator-delete-customer-user-buttons-container button{
    border: none;
    cursor: pointer;
    margin-left: 15px;
    padding: 12px 20px;
    border-radius: 4px;
    color: white;
    font-size: 15px;
    font-weight: 700;
}
.tenant-administrator-delete-customer-user-buttons-container .cancel-delete-button{
    background-color: rgb(54, 91, 133);
}
.tenant-administrator-delete-customer-user-buttons-container .delete-button{
    background-color: rgb(172, 27, 24);
}
.tenant-administrator-delete-customer-user-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
}
.tenant-administrator-delete-customer-user-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-delete-customer-user-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-delete-customer-user-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}
/*#region Unregistering customer user*/
.tenant-administrator-unregistering-customer-user-container{
    text-align: center;
    padding: 16px 28px;
    padding-bottom: 12px;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-unregistering-customer-user-container div{
    width: 32px;
    height: 32px;
    display: inline-block;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-unregistering-customer-user-spinner 1s linear infinite;
}
@keyframes tenant-administrator-unregistering-customer-user-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-unregistering-customer-user-container p{
    margin: 10px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    cursor: default;
}
/*#endregion*/
/*#region Deleting customer user*/
.tenant-administrator-deleting-customer-user-container{
    text-align: center;
    padding: 16px 28px;
    padding-bottom: 12px;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-deleting-customer-user-container div{
    width: 32px;
    height: 32px;
    display: inline-block;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-deleting-customer-user-spinner 1s linear infinite;
}
@keyframes tenant-administrator-deleting-customer-user-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-deleting-customer-user-container p{
    margin: 10px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    cursor: default;
}
/*#endregion*/
/*#region Deleted customer user*/
.tenant-administrator-deleted-customer-user-container{
    text-align: center;
    padding: 16px 28px;
    padding-bottom: 12px;
    border-radius: 4px;
    position: relative;
    background-color: white;
}
.tenant-administrator-deleted-customer-user-container h1{
    margin: 0px;
    margin-top: 5px;
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    cursor: default;
    color: rgb(30, 30, 33);
}
.tenant-administrator-deleted-customer-user-container p{
    margin: 15px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    cursor: default;
}
.tenant-administrator-deleted-customer-user-okay-button-container{
    text-align: right;
}
.tenant-administrator-deleted-customer-user-okay-button-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 5px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}
.tenant-administrator-deleted-customer-user-okay-button-container button:hover{
    background-color: rgba(185, 39, 39, 0.952);
}
.tenant-administrator-deleted-customer-user-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
}
.tenant-administrator-deleted-customer-user-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-deleted-customer-user-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-deleted-customer-user-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}
/*#endregion*/
/*#region Unregiser error*/
.tenant-administrator-customer-user-unregister-error-container{
    text-align: center;
    padding: 16px 28px;
    padding-bottom: 12px;
    border-radius: 4px;
    position: relative;
    background-color: white;
}
.tenant-administrator-customer-user-unregister-error-container h1{
    margin: 0px;
    margin-top: 5px;
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    cursor: default;
    color: rgb(133, 0, 0);
}
.tenant-administrator-customer-user-unregister-error-container p{
    margin: 15px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    cursor: default;
}
.tenant-administrator-customer-user-unregister-error-okay-button-container{
    text-align: right;
}
.tenant-administrator-customer-user-unregister-error-okay-button-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 5px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}
.tenant-administrator-customer-user-unregister-error-okay-button-container button:hover{
    background-color: rgba(185, 39, 39, 0.952);
}
.tenant-administrator-customer-user-unregister-error-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
}
.tenant-administrator-customer-user-unregister-error-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-customer-user-unregister-error-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-customer-user-unregister-error-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}
/*#endregion*/
/*#region Delete error*/
.tenant-administrator-customer-user-delete-error-container{
    text-align: center;
    padding: 16px 28px;
    padding-bottom: 12px;
    border-radius: 4px;
    position: relative;
    background-color: white;
}
.tenant-administrator-customer-user-delete-error-container h1{
    margin: 0px;
    margin-top: 5px;
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    cursor: default;
    color: rgb(133, 0, 0);
}
.tenant-administrator-customer-user-delete-error-container p{
    margin: 15px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    cursor: default;
}
.tenant-administrator-customer-user-delete-error-okay-button-container{
    text-align: right;
}
.tenant-administrator-customer-user-delete-error-okay-button-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 5px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}
.tenant-administrator-customer-user-delete-error-okay-button-container button:hover{
    background-color: rgba(185, 39, 39, 0.952);
}
.tenant-administrator-customer-user-delete-error-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
}
.tenant-administrator-customer-user-delete-error-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-customer-user-delete-error-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-customer-user-delete-error-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}
/*#endregion*/`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/DeleteCustomerUser.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,yEAAyE;AAC7E;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,mFAAmF;AACvF;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,sFAAsF;AAC1F;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA,aAAa;AACb,iCAAiC;AACjC;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,iFAAiF;AACrF;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA,aAAa;AACb,gCAAgC;AAChC;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA,aAAa;AACb,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA,aAAa;AACb,uBAAuB;AACvB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA,aAAa","sourcesContent":[".tenant-administrator-delete-customer-user-parent-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.45);\n    font-family: lato, \"Helvetica Neue\", Helvetica, Roboto, Arial, sans-serif;\n}\n.tenant-administrator-delete-customer-user-container{\n    position: relative;\n    opacity: 0;\n    padding: 10px 40px;\n    border-radius: 6px;\n    background-color: white;\n    animation: tenant-administrator-delete-customer-user-slide-in 0.8s ease-in forwards;\n}\n@keyframes tenant-administrator-delete-customer-user-slide-in {\n    from{\n        opacity: 0;\n        transform: translateX(-100%);\n    }\n    80%{\n        opacity: 1;\n        transform: translateX(-8%);\n    }\n    to{\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n.tenant-administrator-delete-customer-user-container h1{\n    margin: 25px 0px;\n    margin-right: 140px;\n    font-size: 24px;\n    font-weight: 700;\n    cursor: default;\n    color: rgb(30, 30, 33);\n}\n.tenant-administrator-delete-customer-user-container p{\n    font-size: 15px;\n    margin: 30px 0px;\n    cursor: default;\n    color: rgb(30, 30, 33);\n}\n.tenant-administrator-delete-customer-user-buttons-container{\n    margin: 20px 0px;\n    text-align: right;\n}\n.tenant-administrator-delete-customer-user-buttons-container button{\n    border: none;\n    cursor: pointer;\n    margin-left: 15px;\n    padding: 12px 20px;\n    border-radius: 4px;\n    color: white;\n    font-size: 15px;\n    font-weight: 700;\n}\n.tenant-administrator-delete-customer-user-buttons-container .cancel-delete-button{\n    background-color: rgb(54, 91, 133);\n}\n.tenant-administrator-delete-customer-user-buttons-container .delete-button{\n    background-color: rgb(172, 27, 24);\n}\n.tenant-administrator-delete-customer-user-escape-button-container{\n    position: absolute;\n    top: 0px;\n    right: -60px;\n    cursor: pointer;\n}\n.tenant-administrator-delete-customer-user-escape-button-container:hover button{\n    color: rgb(96, 96, 96);\n}\n.tenant-administrator-delete-customer-user-escape-button-container button{\n    border: none;\n    font-size: 20px;\n    padding: 10px 16px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: white;\n    color: rgb(175, 175, 175);\n    transition: color 0.25s ease;\n}\n.tenant-administrator-delete-customer-user-escape-button-container p{\n    margin: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 900;\n    cursor: pointer;\n    color: rgb(240, 240, 240);\n}\n/*#region Unregistering customer user*/\n.tenant-administrator-unregistering-customer-user-container{\n    text-align: center;\n    padding: 16px 28px;\n    padding-bottom: 12px;\n    border-radius: 4px;\n    background-color: white;\n}\n.tenant-administrator-unregistering-customer-user-container div{\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    border: 2px solid rgba(155, 30, 30, 0.952);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: tenant-administrator-unregistering-customer-user-spinner 1s linear infinite;\n}\n@keyframes tenant-administrator-unregistering-customer-user-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-unregistering-customer-user-container p{\n    margin: 10px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    cursor: default;\n}\n/*#endregion*/\n/*#region Deleting customer user*/\n.tenant-administrator-deleting-customer-user-container{\n    text-align: center;\n    padding: 16px 28px;\n    padding-bottom: 12px;\n    border-radius: 4px;\n    background-color: white;\n}\n.tenant-administrator-deleting-customer-user-container div{\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    border: 2px solid rgba(155, 30, 30, 0.952);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: tenant-administrator-deleting-customer-user-spinner 1s linear infinite;\n}\n@keyframes tenant-administrator-deleting-customer-user-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-deleting-customer-user-container p{\n    margin: 10px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    cursor: default;\n}\n/*#endregion*/\n/*#region Deleted customer user*/\n.tenant-administrator-deleted-customer-user-container{\n    text-align: center;\n    padding: 16px 28px;\n    padding-bottom: 12px;\n    border-radius: 4px;\n    position: relative;\n    background-color: white;\n}\n.tenant-administrator-deleted-customer-user-container h1{\n    margin: 0px;\n    margin-top: 5px;\n    font-size: 20px;\n    font-weight: 500;\n    text-align: left;\n    cursor: default;\n    color: rgb(30, 30, 33);\n}\n.tenant-administrator-deleted-customer-user-container p{\n    margin: 15px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    cursor: default;\n}\n.tenant-administrator-deleted-customer-user-okay-button-container{\n    text-align: right;\n}\n.tenant-administrator-deleted-customer-user-okay-button-container button{\n    border: none;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: 5px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in-out;\n}\n.tenant-administrator-deleted-customer-user-okay-button-container button:hover{\n    background-color: rgba(185, 39, 39, 0.952);\n}\n.tenant-administrator-deleted-customer-user-escape-button-container{\n    position: absolute;\n    top: 0px;\n    right: -60px;\n    cursor: pointer;\n}\n.tenant-administrator-deleted-customer-user-escape-button-container:hover button{\n    color: rgb(96, 96, 96);\n}\n.tenant-administrator-deleted-customer-user-escape-button-container button{\n    border: none;\n    font-size: 20px;\n    padding: 10px 16px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: white;\n    color: rgb(175, 175, 175);\n    transition: color 0.25s ease;\n}\n.tenant-administrator-deleted-customer-user-escape-button-container p{\n    margin: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 900;\n    cursor: pointer;\n    color: rgb(240, 240, 240);\n}\n/*#endregion*/\n/*#region Unregiser error*/\n.tenant-administrator-customer-user-unregister-error-container{\n    text-align: center;\n    padding: 16px 28px;\n    padding-bottom: 12px;\n    border-radius: 4px;\n    position: relative;\n    background-color: white;\n}\n.tenant-administrator-customer-user-unregister-error-container h1{\n    margin: 0px;\n    margin-top: 5px;\n    font-size: 20px;\n    font-weight: 500;\n    text-align: left;\n    cursor: default;\n    color: rgb(133, 0, 0);\n}\n.tenant-administrator-customer-user-unregister-error-container p{\n    margin: 15px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    cursor: default;\n}\n.tenant-administrator-customer-user-unregister-error-okay-button-container{\n    text-align: right;\n}\n.tenant-administrator-customer-user-unregister-error-okay-button-container button{\n    border: none;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: 5px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in-out;\n}\n.tenant-administrator-customer-user-unregister-error-okay-button-container button:hover{\n    background-color: rgba(185, 39, 39, 0.952);\n}\n.tenant-administrator-customer-user-unregister-error-escape-button-container{\n    position: absolute;\n    top: 0px;\n    right: -60px;\n    cursor: pointer;\n}\n.tenant-administrator-customer-user-unregister-error-escape-button-container:hover button{\n    color: rgb(96, 96, 96);\n}\n.tenant-administrator-customer-user-unregister-error-escape-button-container button{\n    border: none;\n    font-size: 20px;\n    padding: 10px 16px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: white;\n    color: rgb(175, 175, 175);\n    transition: color 0.25s ease;\n}\n.tenant-administrator-customer-user-unregister-error-escape-button-container p{\n    margin: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 900;\n    cursor: pointer;\n    color: rgb(240, 240, 240);\n}\n/*#endregion*/\n/*#region Delete error*/\n.tenant-administrator-customer-user-delete-error-container{\n    text-align: center;\n    padding: 16px 28px;\n    padding-bottom: 12px;\n    border-radius: 4px;\n    position: relative;\n    background-color: white;\n}\n.tenant-administrator-customer-user-delete-error-container h1{\n    margin: 0px;\n    margin-top: 5px;\n    font-size: 20px;\n    font-weight: 500;\n    text-align: left;\n    cursor: default;\n    color: rgb(133, 0, 0);\n}\n.tenant-administrator-customer-user-delete-error-container p{\n    margin: 15px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    cursor: default;\n}\n.tenant-administrator-customer-user-delete-error-okay-button-container{\n    text-align: right;\n}\n.tenant-administrator-customer-user-delete-error-okay-button-container button{\n    border: none;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: 5px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in-out;\n}\n.tenant-administrator-customer-user-delete-error-okay-button-container button:hover{\n    background-color: rgba(185, 39, 39, 0.952);\n}\n.tenant-administrator-customer-user-delete-error-escape-button-container{\n    position: absolute;\n    top: 0px;\n    right: -60px;\n    cursor: pointer;\n}\n.tenant-administrator-customer-user-delete-error-escape-button-container:hover button{\n    color: rgb(96, 96, 96);\n}\n.tenant-administrator-customer-user-delete-error-escape-button-container button{\n    border: none;\n    font-size: 20px;\n    padding: 10px 16px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: white;\n    color: rgb(175, 175, 175);\n    transition: color 0.25s ease;\n}\n.tenant-administrator-customer-user-delete-error-escape-button-container p{\n    margin: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 900;\n    cursor: pointer;\n    color: rgb(240, 240, 240);\n}\n/*#endregion*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
